
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.583 14a.75.75 0 001.5 0h-1.5zm9.334 0a.75.75 0 001.5 0h-1.5zm-7.834-.666c0-1.69 1.641-3.25 3.917-3.25v-1.5c-2.879 0-5.417 2.022-5.417 4.75h1.5zM8 10.084c2.276 0 3.917 1.56 3.917 3.25h1.5c0-2.728-2.538-4.75-5.417-4.75v1.5zm-5.417 3.25v.667h1.5v-.667h-1.5zm10.834.667v-.667h-1.5v.667h1.5zM9.917 4.667A1.917 1.917 0 018 6.583v1.5a3.417 3.417 0 003.417-3.416h-1.5zM8 6.583a1.917 1.917 0 01-1.917-1.916h-1.5A3.417 3.417 0 008 8.083v-1.5zM6.083 4.667c0-1.059.858-1.917 1.917-1.917v-1.5a3.417 3.417 0 00-3.417 3.417h1.5zM8 2.75c1.059 0 1.917.858 1.917 1.917h1.5A3.417 3.417 0 008 1.25v1.5z"}})])
          )
        }
      }
    